import axios from 'axios';
import {
  httpErrorHandler,
  httpSuccessHandler,
  httpSetRequestHeaders,
} from '@ncl/modules/shared/services/httpMiddleware';
import { fireGTMEvent } from '@ncl/utils';
import AccountStore from '../../account/store/AccountStore';
import QuoteStore from '../../quote/store/QuoteStore';
import flowStore from '../store/FlowStore';

class CoreServices {
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    this.instance.interceptors.response.use(httpSuccessHandler, (error) => {
      return httpErrorHandler(error, this.instance);
    });
    this.instance.interceptors.request.use(httpSetRequestHeaders);

    this.instance.defaults.raxConfig = {
      instance: this.instance,
    };
  }

  getInstance() {
    return this.instance;
  }

  async searchCity(s) {
    return this.instance.get(`/cities?name=${s}`);
  }

  async sendContactInfo() {
    const { policyholder } = AccountStore;
    const { modality } = flowStore;
    const { cgcCnpj } = policyholder;
    const { Email, Phone } = QuoteStore;

    const data = {
      PolicyholderFederalId: cgcCnpj,
      ModalityName: modality,
    };

    data.Email = Email;
    data.Phone = Phone;

    return this.instance.post('/quotes/modalitynotallowed', data);
  }

  triggerPageView(pathname) {
    fireGTMEvent('pageview', { pagina: pathname });
  }

  triggerLeadDataLayer(novoLead) {
    const { policyholder } = AccountStore;

    const key = `leadRegistered:${policyholder.cgcCnpj}`;
    const alreadyRegistered = sessionStorage.getItem(key);
    fireGTMEvent('Lead Salvo', {
      novoLead: alreadyRegistered ? 'false' : Boolean(novoLead).toString(),
    });

    sessionStorage.setItem(key, true);
    return true;
  }

  getUsernameFirstCharacter() {
    const { currentUser } = AccountStore;

    if (currentUser.displayName) {
      return currentUser.displayName[0];
    }
    return '?';
  }

  verifyCnpj(cnpj) {
    return this.instance.get(`/valid?cnpj=${cnpj}`);
  }

  triggerFlowBackButtonTag() {
    const { ModalityId } = QuoteStore;

    if (ModalityId === 122 || QuoteStore.ModalityId === 76 || QuoteStore.ModalityId === 78) {
      fireGTMEvent('NC_Judicial', { judicialFlowAction: 'Click-Judicial-Voltar' });
    }
  }
}

const services = new CoreServices();
export default services;
